<template>
    <div class="tip" v-if="!isShow">{{ value }}</div>
    <a-tooltip v-else>
      <template #title>
        <div v-html="isSeq ? showTextSequence(value) : value"></div>
      </template>
      <div class="tip" :style="{'width': width ? width + 'px' : '100%'}">{{ value }}</div>
    </a-tooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { showTextSequence } from '@/utils/tool';
const props = defineProps(['width', 'value', 'isSeq'])
const isShow = computed(() => {
  if(props.width) {
    if(props.width > String(props.value).length * 14) {
      return false
    }
    return true
  }
  return false
})
</script>

<style scoped>
.tip {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all ;
}
.tip-seq {
  width: 500px;
}
</style>